/**
 * author: Soumya Shreyas
 * Company Selection Context
 */

import React, { useEffect, useState, useContext } from "react";
import { Form } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import CompanyService from "../../core/service/CompanyService";
import { RegulationContext, CompanyContext } from "../../App";
import { LS_AUTHORITY_KEY } from "../../core/constants/common";

function CompanySelectBox({ t }) {
  const {
    glbCompany,
    setGlbCompany,
    glbCompanies,
    setGlbCompanies
  } = useContext(CompanyContext);
  const { setGlbRegulation } =useContext(RegulationContext);
  const data = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    if (data && data.roles.includes("SUPPLIER_ADMIN")) {
      getCompanyAssociations();
    }
  }, [glbCompanies]);
  const getCompanyAssociations = async () => {
    const companyId = data.profile.company.id;
    if (companyId) {
      CompanyService.getCompanyAssociations(companyId)
        .then((response) => {
          setGlbCompany(response.data.length > 0 ? response.data[0] : "");
          setCompanies([...response.data]);
        })
        .catch((error) => {
        });
    }
  };
  const handleChange = (e) => {
    let val = e.target.value;
    setGlbRegulation({});
    if (val === "all") {
      setGlbCompany({companyId:-1});
    } else {
      const found = companies.find((obj) => {
        return obj.companyId === parseInt(val);
      });
      setGlbCompany(found);
    }
  };
  return (
    <>
      <Form>
        <select
          className="form-select"
          onChange={(e) => handleChange(e)}
          value={glbCompany?.companyId ? glbCompany.companyId : "all"}
        >
          <option value="" disabled hidden>
            {t("Select.label")}
          </option>
          <option value="all">{t("ALL.label")}</option>
          {companies?.map((item, index) => (
            <option value={item.companyId} key={index}>
              {item.legalName}
            </option>
          ))}
        </select>
      </Form>
    </>
  );
}

export default withTranslation()(CompanySelectBox);
